<div class="d-flex flex-row flex-lg-column container-filter-label aling-items-center">
    <span class="filter-label" [class.active]="filter.selected === true" *ngFor="let filter of filterList" (click)="onFilterChange(filter)">
        {{filter.displayText | translate}}
    </span>
</div>